/* eslint-disable local-rules/no-window-dimensions */
import { debounce } from 'underscore';

type SizeListeners = { setWidth: (width: number) => void; setHeight: (height: number) => void };

/*

Just calling window.innerHeight or window.innerWidth forces a page repaint
and calling it recursively causes a lot of jank on the page. Tucking all uses
into this single class allows us to reduce repaints but still update components 
with updated window size numbers.

*/
class GlobalWindowSize {
  private listeners: Set<SizeListeners> = new Set();
  public innerHeight = window.innerHeight;
  public innerWidth = window.innerWidth;

  constructor() {
    const handler = debounce(this.handleResize, 50);
    window.addEventListener('resize', handler);
  }

  callListeners = () => {
    this.listeners.forEach((listener) => {
      listener.setWidth(this.innerWidth);
      listener.setHeight(this.innerHeight);
    });
  };

  handleResize = () => {
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
    this.callListeners();
  };

  addEventListener(listener: SizeListeners) {
    this.listeners.add(listener);
  }

  removeEventListener(listener: SizeListeners) {
    this.listeners.delete(listener);
  }

  update(listener: SizeListeners) {
    listener.setHeight(this.innerHeight);
    listener.setWidth(this.innerWidth);
  }

  forceUpdateAll() {
    this.handleResize();
  }
}

const globalWindowSize = new GlobalWindowSize();
export default globalWindowSize;
